import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";

export interface RuntimeConfig {
  shortEnv: string;
  projectId: string;
  globalAuthUrl: string;
}

@Injectable()
export class RuntimeConfigService {
  get value(): Promise<RuntimeConfig> {
    return this.getConfig();
  }

  constructor(private injector: Injector) {}

  private config?: Promise<RuntimeConfig>;
  private getConfig(): Promise<RuntimeConfig> {
    if (this.config == null) {
      this.config = this.getHttpClient()
        .then((http) => {
          return http
            .get<RuntimeConfig>("runtime-config.json", {
              // TODO: is there a better way to do this?
              headers: {
                authorization: ""
              }
            })
            .toPromise();
        })
        .catch(() => {
          // TODO: add this to develop servers and stuff
          return {
            shortEnv: "dev",
            projectId: "dev",
            globalAuthUrl: "https://auth.tapad.com"
          };
        });
    }
    return this.config;
  }

  private getHttpClient(): Promise<HttpClient> {
    return new Promise((resolve) => {
      resolve(this.injector.get(HttpClient));
    });
  }
}
